/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-01-06 14:26:59
 * @LastEditors: WangYuhan
 */
// 结算单类型
export const settlementTypes = [
  { label: '预付运费', value: 'PAYADVANCE' },
  { label: '到付运费', value: 'PAYARRIVE' },
  { label: '回单押金', value: 'PAYBACK' },
];
// 交易类型
export const transactionNetGoodsTypes = [
  { label: '储值', value: 'RECHARGE' },
  { label: '油气充值', value: 'OILRECHARGE' },
  { label: 'ETC充值', value: 'ETCRECHARGE' },
  { label: '网货交易', value: 'NETFREIGHT' },
];

// 交易类型
export const transTypes = [
  { label: '全部', value: '' },
  { label: '储值', value: 'app_financial_deposit' },
  { label: '外协车消费', value: 'app_etcwx' },
  { label: '自有车消费', value: 'app_etczy' },
  { label: '退款', value: 'rush_out' },
];
// 收支类型
export const consumerTypes = [
  { label: '全部', value: '' },
  { label: '支出', value: 'xf' },
  { label: '收入', value: 'cz' },
];

export const tabbarnetFan = [
  {
    label: '待开票',
    value: 'PAYING',
    status: 'payingNum',
  },
  {
    label: '已申请',
    value: 'LINE_PAYING',
    status: 'linePayingNum',
  },
  {
    label: '开票中',
    value: 'REFUSE',
    status: 'refuseNum',
  },
  {
    label: '已开票',
    value: 'SUCCESS',
    status: 'finishNum',
  },
];
